export default __webpack_public_path__ + "static/media/background2.89f94e05.svg";